export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_LOADER = 'SHOW_LOADER';
export const ADD_NOTE = 'ADD_NOTE';
export const FETCH_NOTES = 'FETCH_NOTES';
export const REMOVE_NOTE = 'REMOVE_NOTE';